import * as actionTypes from '../actions/common'

const initialState = {
  kenmeiCodes: [],
}

const kenmeiList = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REDUCER_SET_KENMEI_CODES:

      const {kenmeiCodes} = action.payload

      const convKenmeiCodes = kenmeiCodes.map((data) => {
        return {
          textKey: `${data.kenmeiCode} - ${data.kenmeiName}`,
          valueKey: data
        }
      })

      return Object.assign({}, state, {kenmeiCodes: convKenmeiCodes})

    default:
      return state
  }
}

export default kenmeiList


// WEBPACK FOOTER //
// ./src/reducers/common.js